export default __webpack_public_path__ + "static/media/goodmorning.af5e5928.mpga";